import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SearchIcon, XIcon } from 'lucide-react';
interface SearchWordsProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  resultsCount?: number;
  className?: string;
}
export function SearchWords({
  value,
  onChange,
  onClear,
  resultsCount,
  className = ''
}: SearchWordsProps) {
  const {
    isArabic
  } = useLanguage();
  return <div className={`relative ${className}`} data-id="element-1349">
      <div className="relative" data-id="element-1350">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1351">
          <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1352" />
        </div>
        <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={isArabic ? 'ابحث عن كلمات...' : 'Search words...'} className="w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-1353" />
        {value && <button onClick={onClear} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1354">
            <XIcon className="h-5 w-5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" data-id="element-1355" />
          </button>}
      </div>
      {typeof resultsCount !== 'undefined' && <div className="absolute right-3 top-full mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-1356">
          {isArabic ? `${resultsCount} نتيجة` : `${resultsCount} result${resultsCount !== 1 ? 's' : ''}`}
        </div>}
    </div>;
}